export { AtnDsAdaptiveCardComponent as Component } from './adaptive-card.component'
